import { motion } from 'framer-motion'

import { CompanyModal } from '@apps-common/apps/portal/pages/management/components/company'
import { ButtonRoundedWithIcon } from '@apps-common/components/elements'
import { VertSpacerLg, VertSpacerMd } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { GRID_CARD_VARIANTS } from '@apps-common/config/motion-variants'
import { valueStringCheck } from '@apps-common/helpers/value-string-check'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { ICompanyListModel } from '@apps-common/types/management/company'

interface IProps {
  company: ICompanyListModel
  companies?: ICompanyListModel[]
}
export const CompanyListCard = ({ company, companies }: IProps) => {
  const { companyId, companyName, defaultMonitoringCentreName } = company

  return (
    <motion.div
      key={`company-list-card-${company.id}`}
      variants={GRID_CARD_VARIANTS}
      className='w-full p-6 rounded-[35px] bg-surface text-text border border-border'
    >
      <div className='flex items-start justify-between w-full'>
        <div className='jost'>{companyName}</div>
      </div>
      <div className='flex flex-col gap-[5px] text-[0.9em]'>
        <VertSpacerMd />
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize'>
          <p className='jost-light text-md text-ellipsis overflow-hidden bg-surface-2 text-[0.9em] leading-[1em] p-1 rounded'>
            Default MC:
          </p>
          <p className='jost-light text-sm text-ellipsis overflow-hidden'>{valueStringCheck(defaultMonitoringCentreName)}</p>
        </div>
      </div>
      <VertSpacerLg />
      <ModalButton
        classes='w-full flex justify-end'
        component={CompanyModal}
        disabled={false}
        componentProps={{
          companyId,
          companies
        }}
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
      >
        <ButtonRoundedWithIcon
          type='div'
          text='Details'
          icon={<commonIcons.arrowAngled />}
          className='action-brand !w-auto !grow-0'
          iconContainerClassName='bg-brand text-on-brand'
        />
      </ModalButton>
    </motion.div>
  )
}
